// var ses = require('node-ses');
import { SendEmailConfig, SendEmailFields } from '@src/app/_global/domain/sesEmailConfig';
import { AWSError } from 'aws-sdk/global';
// import { resolve } from 'url';
var AWS = require('aws-sdk');

export class SendEmailClient {
  getSessionStorageValue = (value: string): {} | void => {
    var valueString = sessionStorage.getItem(value);
    if (valueString) {
      return JSON.parse(valueString);
    }
  }
  sendEmail = (config: SendEmailConfig): Promise<any | void> => {
    return new Promise((resolve, reject) => {
       if (config.creds) {
        config.creds.get(async (credsErr: AWSError) => {
          if (credsErr) {
            console.log(credsErr);
            reject(credsErr);
          } else {
            AWS.config.update
            ({
              accessKey: config.creds.accessKeyId,
              secretKey: config.creds.secretAccessKey,
              sessionToken: config.creds.sessionToken,
            });
            // Create sendEmail params 
            var params = {
              Destination: { /* required */
                ToAddresses: [
                  config.emailFields.to,
                ]
              },
              Message: { /* required */
                Body: { /* required */
                  Text: {
                  Charset: 'UTF-8',
                  Data: config.emailFields.message
                  }
                },
                Subject: {
                  Charset: 'UTF-8',
                  Data: config.emailFields.subject
                }
              },
              Source: config.emailFields.from, /* required */
              ReplyToAddresses: [
                config.emailFields.replyTo
              ],
            };       

            // Create the promise and SES service object
            var sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendEmail(params).promise();

            // Handle promise's fulfilled/rejected states
            sendPromise.then(
              function(data: any) {
                let emailUUID = params.Message.Body.Text.Data.slice(params.Message.Body.Text.Data.indexOf('GC Email Session'));
                console.error('GC Email SES messageId: ' + data.MessageId);
                console.error(emailUUID);
                return(data);
              }).catch(
                function(err: any) {
                console.error(err, err.stack);
                return (err);
              });
              resolve(sendPromise);
          }
        });

      } else {
        reject('no config creds');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_global/utility/sendEmailUtils.ts